export default __webpack_public_path__ + "static/media/woman.8a11d0bd.jpg";